import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

const useTask = () => {
  const [searchParams] = useSearchParams();
  
  // Initialize from searchParams immediately to avoid null on first render
  const getTaskId = () => {
    if (!searchParams || typeof searchParams.get !== "function") return null;
    const taskIdParam = searchParams.get("taskId");
    return taskIdParam ? Number(taskIdParam) : null;
  };
  
  const [taskId, setTaskId] = useState(() => getTaskId());
  const [frameStart, setFrameStart] = useState(null);
  const [frameEnd, setFrameEnd] = useState(null);
  const [taskType, setTaskType] = useState(() => {
    if (!searchParams || typeof searchParams.get !== "function") return "supertrack";
    const type = searchParams.get("type");
    return ["supertrack", "ball"].includes(type) 
      ? (type === "supertrack" ? "supertrack" : "ball_supertrack")
      : "supertrack";
  });

  const { frameCount } = useSelector(({ superTracks }) => superTracks);

  useEffect(() => {
    if (!searchParams || typeof searchParams.get !== "function") return;
    const taskIdParam = searchParams.get("taskId");
    const frameStartParam = searchParams.get("frame_start");
    const frameEndParam = searchParams.get("frame_end");
    
    setTaskId(taskIdParam ? Number(taskIdParam) : null);
    setFrameStart(frameStartParam ? Number(frameStartParam) : 0);
    setFrameEnd(frameEndParam ? Number(frameEndParam) : frameCount);

    const taskType = searchParams.get("type");
    if (["supertrack", "ball"].includes(taskType))
      setTaskType(taskType === "supertrack" ? "supertrack" : "ball_supertrack");
  }, [searchParams, frameCount]);

  return {
    taskId,
    frameStart,
    frameEnd,
    taskType,
  };
};

export default useTask;
